"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialog = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("../../../../generic");
exports.StyledDialog = (0, styled_components_1.default)(generic_1.ActionDialog) `
  .MuiDialog-paper {
    min-height: auto;
    min-width: 650px;
  }
`;
